import React, {useState, useEffect} from 'react';
import {connect, useDispatch} from 'react-redux';
import {makeStyles} from 'tss-react/mui';
import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import TextField from '@mui/material/TextField';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Tooltip from '@mui/material/Tooltip';
import ReplayIcon from '@mui/icons-material/Replay';
import TimerOffIcon from '@mui/icons-material/TimerOff';
import VisibilityIcon from '@mui/icons-material/Visibility';
//DS
import {showSucces} from 'src/common/toast';
import {SelectPlus, hooks, DialogBase, CardObjeto, ConfirmDialog} from 'lib.front';
import {transformacion} from 'lib.common';

import {esquemaCampos, esquemaValidacion} from './esquemas';
import {urlsCrm} from '../../../config/keys';
import {queryCliente, mutationBaja, mutationReset} from './queries';
import {loadingModal, openMsg} from 'src/redux-app';
import {cmps} from './constantes';

const {denominacionCliente, concatAtributoObjetoArreglo} = transformacion;
const {useApolloLazyQ, useValidacion, useApolloMutation} = hooks;

const useStyles = makeStyles()(theme => ({
   container: {
      marginTop: theme.spacing(2)
   },
   tabla: {
      width: '100%'
   }
}));

function AdministrarLicencias({usuario}) {
   const {classes, cx} = useStyles();
   const operaciones = {
      RESET: 'reset',
      BAJA: 'baja'
   };
   const dispatch = useDispatch();
   //Modal de espera
   function openWaitModal(load) {
      dispatch(loadingModal(load));
   }
   //Modal para mensajes
   function openMsgModal(msg) {
      dispatch(openMsg(msg));
   }
   //Estados
   const {
      campos,
      existeError,
      handleOnChange,
      validacionManual,
      setCampo,
      validarTodos,
      inicializar
   } = useValidacion(esquemaCampos, esquemaValidacion);
   function getClienteCodigo(valor) {
      return valor.split('|')[0];
   }
   function getClienteEmail(valor) {
      if (valor) {
         return valor.split('|')[1];
      }
      return '';
   }

   //Data de cliente
   const [dataCliente, setDataCliente] = useState(null);

   useEffect(() => {
      if (campos.cliente.valor && campos.cliente.valor.label) {
         setCampo('razonSocial', campos.cliente.valor.label.split('-')[1].trimStart());
         setCampo('email', getClienteEmail(campos.cliente.valor.value));
         onClickBuscar();
      }
   }, [campos.cliente.valor]);

   function onClickBuscar() {
      if (campos.cliente.valor && campos.cliente.valor.value !== '') {
         getCliente({variables: {codigoCliente: getClienteCodigo(campos.cliente.valor.value)}});
      }
   }

   function procesarCliente(data) {
      if (data.llavesNoAnuladas) {
         setDataCliente(data);
         //const estadosElegidos = new Array(data.llavesNoAnuladas.length).fill(true);
         //setElegidos(estadosElegidos);
      }
   }

   const [getCliente] = useApolloLazyQ(queryCliente, {
      callbackProcesarData: procesarCliente,
      callbackError: openMsgModal,
      callbackLoading: openWaitModal
   });

   function onBlurValidacion(e) {
      validacionManual(e.target.name, e.target.value);
   }

   //CHECKBOXES
   const [elegidos, setElegidos] = useState([]);
   function toggleCheckBox(index) {
      let nuevoElegidos = elegidos;
      nuevoElegidos[index] = !nuevoElegidos[index];
      setElegidos(nuevoElegidos);
   }
   //INFORMACION ADICIONAL
   const [infoAdicional, setInfoAdicional] = useState(null);
   function closeModalInfoAdicional() {
      setInfoAdicional(null);
   }
   function openModalInfoAdicional(dataLicencia) {
      setInfoAdicional(dataLicencia);
   }
   function verificarInfoAdicional(dataLicencia) {
      const campos = ['ide', 'mac', 'cpu', 'placa', 'bios', 'sisoper', 'ram', 'chip']
      return campos.some(campo => Boolean(dataLicencia[campo]));
   }

   const configuracionInfoAdicional = [
      {
         name: 'ide',
         label: 'Ide',
         options: {
            display: 'false'
         }
      },
      {
         name: 'mac',
         label: 'Mac',
         options: {
            display: 'false'
         }
      },
      {
         name: 'cpu',
         label: 'Cpu',
         options: {
            display: 'false'
         }
      },
      {
         name: 'placa',
         label: 'Placa',
         options: {
            display: 'false'
         }
      },
      {
         name: 'bios',
         label: 'Bios',
         options: {
            display: 'false'
         }
      },
      {
         name: 'sisoper',
         label: 'Sisoper',
         options: {
            display: 'false'
         }
      },
      {
         name: 'ram',
         label: 'Ram',
         options: {
            display: 'false'
         }
      },
      {
         name: 'chip',
         label: 'Chip',
         options: {
            display: 'false'
         }
      }
   ];

   // ===== CONFIRMAR OPERACION =====
   const [tipoOperacion, setTipoOperacion] = useState('');
   const [codigosElegidos, setCodigosElegidos] = useState([]);
   async function openConfirmar(operacion, elegido) {
      const esOkProcesar = await validarTodos();
      if (esOkProcesar) {
         setTipoOperacion(operacion);
         setCodigosElegidos(elegido);
      }
   }
   function closeConfirmar() {
      setTipoOperacion('');
      setCodigosElegidos([]);
   }
   // ===== OPERACIONES =====
   async function procesarOperacionReset(data) {
      if (data.resetearLlaves && data.resetearLlaves.msg !== '') {
         showSucces(data.resetearLlaves.msg);
      }
   }
   const [resetLlaves] = useApolloMutation(mutationReset, {
      callbackProcesarData: procesarOperacionReset,
      callbackError: openMsgModal,
      callbackLoading: openWaitModal
   });

   async function procesarOperacionBaja(data) {
      if (data.darBajaLlaves && data.darBajaLlaves.msg !== '') {
         showSucces(data.darBajaLlaves.msg);
      }
   }
   const [darBajaLlaves] = useApolloMutation(mutationBaja, {
      callbackProcesarData: procesarOperacionBaja,
      callbackError: openMsgModal,
      callbackLoading: openWaitModal
   });

   async function confirmarOperacion() {
      let variables = {
         usuario: usuario.usuario,
         razon: campos.observaciones.valor
      };
      variables.codigos = await concatAtributoObjetoArreglo(codigosElegidos, 'codigo', ',');
      switch (tipoOperacion) {
         case operaciones.RESET:
            resetLlaves({variables});
            break;
         case operaciones.BAJA:
            darBajaLlaves({variables});
            break;
         default:
            break;
      }
   }
   // Funciones
   function genDenomiacionProducto(registro) {
      const producto = registro.producto.split('-')[1];
      const presentacion = registro.presentacion.split('-')[1];
      const version = registro.version.split('-')[1];
      return `${producto} ${presentacion} ${version}`;
   }
   function inicializarFormulario() {
      inicializar();
      setInfoAdicional(null);
      closeConfirmar();
      setDataCliente(null);
   }

   return (
      <Container className={cx('containerbox', classes.container)} maxWidth="md">
         <Grid container spacing={1}>
            <Grid item xs={12}>
               <Typography variant="h4" gutterBottom align="center">
                  Administrar Licencias
               </Typography>
            </Grid>
            <Grid container item xs={12} spacing={1}>
               <Grid container item xs={12} spacing={1} alignItems="center">
                  <Grid item xs={7}>
                     <SelectPlus
                        url={urlsCrm.graph}
                        name={cmps.CLIENTE}
                        label="RUC"
                        entidad="clientes"
                        campos={[
                           'codigo',
                           'nombre',
                           'apPaterno',
                           'apMaterno',
                           'razonSocial',
                           'nroDoc',
                           'email'
                        ]}
                        value={campos.cliente.valor}
                        onChange={elegido => {
                           validacionManual('cliente', elegido);
                           if (elegido) {
                              validacionManual('email', getClienteEmail(elegido.value));
                           }
                        }}
                        genId={registro => {
                           return `${registro.nroDoc}|${registro.email}`;
                        }}
                        genLabel={denominacionCliente}
                        error={campos.cliente.error !== ''}
                        helperText={campos.cliente.error}
                        InputLabelProps={{shrink: true}}
                        variant="outlined"
                        margin="dense"
                        fullWidth
                        excesoElementos
                        recuperarOnFocus
                        required
                        placeholder="Elija un cliente:"
                     />
                  </Grid>
                  <Grid item xs={5}>
                     <TextField
                        label="Razón Social"
                        name={cmps.RAZON_SOCIAL}
                        variant="outlined"
                        margin="dense"
                        fullWidth
                        required
                        value={campos.razonSocial.valor}
                        disabled={true}
                     />
                  </Grid>
                  <Grid item xs={12}>
                     <TextField
                        label="Razón de modificación"
                        name={cmps.OBSERVACIONES}
                        variant="outlined"
                        margin="dense"
                        fullWidth
                        required
                        value={campos.observaciones.valor}
                        error={campos.observaciones.error !== ''}
                        helperText={campos.observaciones.error}
                        onChange={handleOnChange}
                        onBlur={onBlurValidacion}
                        multiline
                     />
                  </Grid>
               </Grid>
               <Grid container item xs={12}>
                  {dataCliente && (
                     <TableContainer component={Paper}>
                        <Table size="small">
                           <TableHead>
                              <TableRow>
                                 <TableCell></TableCell>
                                 <TableCell>Documento</TableCell>
                                 <TableCell>Descripcion</TableCell>
                                 <TableCell>Código de Activación</TableCell>
                                 <TableCell>
                                    <Tooltip arrow title="Resetear todos los códigos de activación">
                                       <IconButton
                                          size="small"
                                          color="primary"
                                          onClick={async () => {
                                             if (dataCliente.llavesNoAnuladas) {
                                                openConfirmar(
                                                   operaciones.RESET,
                                                   dataCliente.llavesNoAnuladas
                                                );
                                             }
                                          }}
                                          disabled={existeError}
                                       >
                                          <ReplayIcon />
                                       </IconButton>
                                    </Tooltip>
                                 </TableCell>
                                 <TableCell>
                                    <Tooltip
                                       arrow
                                       title="Dar de baja todos los códigos de activación"
                                    >
                                       <IconButton
                                          size="small"
                                          color="primary"
                                          onClick={() => {
                                             if (dataCliente.llavesNoAnuladas) {
                                                openConfirmar(
                                                   operaciones.BAJA,
                                                   dataCliente.llavesNoAnuladas
                                                );
                                             }
                                          }}
                                          disabled={existeError}
                                       >
                                          <TimerOffIcon />
                                       </IconButton>
                                    </Tooltip>
                                 </TableCell>
                              </TableRow>
                           </TableHead>
                           <TableBody>
                              {dataCliente.llavesNoAnuladas.map((llave, index) => {
                                 return (
                                    <TableRow key={llave.codigo}>
                                       {/*
                                       <TableCell component="th" scope="row">
                                          <Checkbox
                                             checked={elegidos[index]}
                                             onChange={() => {
                                                toggleCheckBox(index);
                                             }}
                                          />
                                       </TableCell>
                                       */}
                                       <TableCell>
                                          <Tooltip arrow title="Ver información adicional">
                                             <span>
                                                <IconButton
                                                   size="small"
                                                   onClick={() => {
                                                      openModalInfoAdicional(llave);
                                                   }}
                                                   color='primary'
                                                   disabled={!verificarInfoAdicional(llave)}
                                                >
                                                   <VisibilityIcon />
                                                </IconButton>
                                             </span>
                                          </Tooltip>
                                       </TableCell>
                                       <TableCell component="th" scope="row">
                                          {llave.documento}
                                       </TableCell>
                                       <TableCell>{llave.producto}</TableCell>
                                       <TableCell component="th" scope="row">
                                          {llave.codigo}
                                       </TableCell>
                                       <TableCell>
                                          <Tooltip arrow title="Resetear este código de activación">
                                             <IconButton
                                                size="small"
                                                onClick={() => {
                                                   openConfirmar(operaciones.RESET, [llave]);
                                                }}
                                                disabled={existeError}
                                             >
                                                <ReplayIcon />
                                             </IconButton>
                                          </Tooltip>
                                       </TableCell>
                                       <TableCell>
                                          <Tooltip
                                             arrow
                                             title="Dar de baja este codigo de activación"
                                          >
                                             <IconButton
                                                size="small"
                                                onClick={() => {
                                                   openConfirmar(operaciones.BAJA, [llave]);
                                                }}
                                                disabled={existeError}
                                             >
                                                <TimerOffIcon />
                                             </IconButton>
                                          </Tooltip>
                                       </TableCell>
                                    </TableRow>
                                 );
                              })}
                           </TableBody>
                        </Table>
                     </TableContainer>
                  )}
               </Grid>
            </Grid>
         </Grid>
         <DialogBase
            open={infoAdicional !== null}
            onClose={closeModalInfoAdicional}
            maxWidth={false}
         >
            <CardObjeto
               value={infoAdicional}
               configuracion={configuracionInfoAdicional}
               titulo={`Llave: ${infoAdicional && infoAdicional.codigo}`}
            />
         </DialogBase>
         <ConfirmDialog
            variant="warning"
            open={tipoOperacion !== ''}
            setOpen={closeConfirmar}
            onConfirm={confirmarOperacion}
         >
            ¿Está seguro que desea
            {tipoOperacion === operaciones.RESET && ' RESETEAR '}
            {tipoOperacion === operaciones.BAJA && ' DAR DE BAJA '}
            {codigosElegidos.length > 0
               ? codigosElegidos.length === 1
                  ? `el siguiente código de activación ${codigosElegidos[0].codigo}`
                  : `varios códigos de activación`
               : ''}
            ?
         </ConfirmDialog>
      </Container>
   );
}
function mapStateToProps(state) {
   return {
      usuario: state.auth.usuario
   };
}

function mapDispatchToProps(dispatch) {
   return {};
}

export default connect(mapStateToProps, mapDispatchToProps)(AdministrarLicencias);
